import { KEY_CODE } from "../../../../../utils/dom/keyCodeMapping";

/**
 * Возвращаем false для всех ключей, которые уже имеют свой функиональный смысл
 * @param key
 */
export const isCurrentKey = (key: KeyboardEvent["key"]): boolean => {
    switch (key) {
        case KEY_CODE.ARROW_UP:
        case KEY_CODE.ARROW_DOWN:
        case KEY_CODE.ENTER:
        case KEY_CODE.SPACE:
            return false;
        default:
            return true;
    }
};
